var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHalal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M12.851 0C6.292 0 0.925537 5.36646 0.925537 11.9255C0.925537 18.4845 6.292 23.8509 12.851 23.8509C19.41 23.8509 24.7765 18.4845 24.7765 11.9255C24.7765 5.36646 19.41 0 12.851 0Z",
    fill: "#22AC38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9938 12.8199V14.5341C18.441 14.5341 18.8882 14.9068 18.8882 15.4286V16.323H17.9938C17.5466 16.323 17.0994 15.9503 17.0994 15.4286V5.88818H15.3851V12C14.2671 11.031 13.6708 9.54036 13.6708 8.04967V5.88818H11.9565V8.04967C11.9565 9.39129 12.3292 10.6584 13 11.7764C13.5963 12.7453 14.4162 13.5652 15.3851 14.1615V14.5341C15.3851 15.5031 14.6398 16.2484 13.6708 16.2484H11.9565V17.9627H13.6708C14.5652 17.9627 15.3851 17.59 15.9814 17.0683C16.4286 17.6646 17.1739 17.9627 17.9938 17.9627H20.6025V15.354C20.6025 13.9379 19.4845 12.8199 17.9938 12.8199Z",
    fill: "#22AC38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52801 15.354C8.52801 15.8012 8.15534 16.2484 7.6336 16.2484C7.11186 16.2484 6.73919 15.8758 6.73919 15.354V12.7453H5.0249V15.354C5.0249 16.7702 6.21745 17.9627 7.6336 17.9627C9.04975 17.9627 10.2423 16.7702 10.2423 15.354V5.88818H8.52801V15.354Z",
    fill: "#22AC38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalal);
export default __webpack_public_path__ + "static/media/halal.63e7c05e.svg";
export { ForwardRef as ReactComponent };